import types from "../actionTypes";

/************************************ ACTIONS ****************************************/

function setMinimumFormStepAction(minSteps) {
  return {
    type: types.SET_COMPANY_MIN_STEPS,
    minSteps,
  };
}

function setMaximumFormStepAction(maxSteps) {
  return {
    type: types.SET_COMPANY_MAX_STEPS,
    maxSteps,
  };
}

function setCurrentFormStepAction(step) {
  return {
    type: types.SET_COMPANY_CURRENT_STEP,
    step,
  };
}

/************************************ ACTION CREATORS ****************************************/

//Setting form step count

export const setMaximumFormStep = (maxCount) => (dispatch) => {
  dispatch(setMaximumFormStepAction(maxCount));
};

export const setMinimumFormStep = (minCount) => (dispatch) => {
  dispatch(setMinimumFormStepAction(minCount));
};

export const setCurrentFormStep = (stepCount) => (dispatch) => {
  dispatch(setCurrentFormStepAction(stepCount));
};
